// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7vNnj","right":"styles_right__1m1pH"};